import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

export const getIntersentionRecentYear = async (station_id) => {
    try {
        return axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: station_id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          return response.data.data
        } else {
            return [];
        }
      })
    }
    catch (error) {
        return [];
    }
}
export const getIntersectionDatePeakData = async (station_id) => {
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getIntersectionDatePeakData,
        data: {
          stationId: station_id
        }
      }).then(function (response) {
        let result = {};
        let movementData = {};
        if (response && response.data.data) {
            if (response && response.data.data) {                
                let data = response.data.data;
                result['peakData'] = data;
                //setPeakData(data);
                let tempPeakArr = [];
                let tempPeakValArr = [];
                data.map((val) => {
                  tempPeakValArr.push(val.date);
                  let date = new Date(val.date);
                  const monthIndex = date.getMonth();
                  const monthName = months[monthIndex];
                  const dayIndex = date.getDay();
                  const dayName = days[dayIndex];
                  tempPeakArr.push(val.date);
                });
                result['selectedDate'] = tempPeakValArr[0];
                //setSelectedDate(tempPeakValArr[0]);
                result['dateVal'] = tempPeakValArr;
                //setDateVal(tempPeakValArr);
                result['peakDate'] = tempPeakArr;
                //setPeakDate(tempPeakArr);        
                if (data && data[0] && data[0].am) {
                  //setAMdata(data[0].am);                
                  //setAmHasData((data[0].am.count == 0)?true : false);  
                  result['AMdata'] = data[0].am;
                  result['AmHasData'] = (data[0].am.count == 0)?true : false;
                }
                if (data && data[0] && data[0].mid) {
                  //setMIDdata(data[0].mid);
                  //setMidHasData((data[0].mid.count == 0)?true : false);

                  result['MIDdata'] = data[0].mid;
                  result['MidHasData'] = (data[0].mid.count == 0)?true : false;
                }
                if (data && data[0] && data[0].pm) {
                  //setPMdata(data[0].pm);
                  //setPmHasData((data[0].pm.count == 0)?true : false);

                  result['PMdata'] = data[0].pm;
                  result['PmHasData'] = (data[0].pm.count == 0)?true : false;
                }           
                 
                //start turning data 
                let dataR = null;
                if(data && data[0]){
                  if(!dataR && data[0].pm.count){
                    dataR = data[0].pm;
                    //setTimePeriod('PM')
                    result['timePeriod'] = 'PM';
                  }
                  if(!dataR && data[0].am.count){
                    dataR = data[0].am;
                    //setTimePeriod('AM');
                    result['timePeriod'] = 'AM';
                  }
                  if(!dataR && data[0].mid.count){
                    dataR = data[0].mid;
                    //setTimePeriod('MID')
                    result['timePeriod'] = 'MID';
                  }                    
                            
                  result['timeData'] = dataR;
                  //getTruckPercentage(dataR);
                  //getPedestrianMovement(dataR);
                  //getBicycleMovement(dataR);                 
                } 
            }
            return result;
        }            
        else {
            return [];
        }
      })
    }
    catch (error) {
        return [];
    }
}  
export const getIntersectionTurningMovement = async (timeData,station_id) => {
    let amDataStart;
    let amDataEnd;
    if (timeData.hour) {
    amDataStart = timeData.hour.peakstartdate;
    amDataEnd = timeData.hour.peakenddate;
    }
    else {
    amDataStart = "";
    amDataEnd = "";
    }
    try {
    return axios({
        method: 'post',
        url: API_URL + API_PATH.getTurningMovement,
        data: {
        "stationId": station_id,
        "start": amDataStart,
        "end": amDataEnd,
        "hour_volume": timeData.hour.volume,
        "minute_volume": timeData.minute.volume
        }
    }).then(function (response) {
        if (response && response.data.data) {
        let data = response.data.data;
        return ({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            centerData: data.phf ? data.phf : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0 
        })
        } else {
        return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        }
    })
        .catch(function (error) {
        return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        })
    }
    catch (error) {
    return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
    }
}
//This method is use for API call to get Turning Movement Data .... End 
//This method is use for API call to get Truck Percentage Data .... Start
export const getIntersectionTruckPercentage = (timeData,station_id) => {
    let amDataStart;
    let amDataEnd;
    if (timeData.hour) {
      amDataStart = timeData.hour.peakstartdate;
      amDataEnd = timeData.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getTruckPercentage,
        data: {
          "stationId": station_id,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          return ({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0
          });
        } else {
          return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        }
      })
        .catch(function (error) {
          return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        })
    }
    catch (error) {
      return ({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
    }
  }
  //This method is use for API call to get Pedestrian Movement Data .... Start
  export const getIntersectionPedestrianMovement = (timeData,station_id) => {
    let amDataStart;
    let amDataEnd;
    if (timeData.hour) {
      amDataStart = timeData.hour.peakstartdate;
      amDataEnd = timeData.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getPedestrianMovement,
        data: {
          "stationId": station_id,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          return ({
            pedNb: data.north.middle ? data.north.middle : 0, pedSb: data.south.middle ? data.south.middle : 0, pedEb: data.east.middle ? data.east.middle : 0, pedWb: data.west.middle ? data.west.middle : 0
          });
        } else {
          return ({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        }
      })
        .catch(function (error) {
          return ({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        })
    }
    catch (error) {
      return ({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
    }
  }
  //This method is use for API call to get Pedestrian Movement Data .... End
  export const getIntersectionBicycleMovement = (timeData,station_id) => {
    let amDataStart;
    let amDataEnd;
    if (timeData.hour) {
      amDataStart = timeData.hour.peakstartdate;
      amDataEnd = timeData.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getBicycleMovement,
        data: {
          "stationId": station_id,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          return ({
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
          });
        } else {
          return ({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        }
      })
        .catch(function (error) {
          return ({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        })
    }
    catch (error) {
      return ({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
    }
  }

  //This method is use for API call to get Pedestrian Movement Data .... End
  export const getIntersectionBicycleCrosswalkMovement = (timeData,station_id) => {
    let amDataStart;
    let amDataEnd;
    if (timeData.hour) {
      amDataStart = timeData.hour.peakstartdate;
      amDataEnd = timeData.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getBicycleCrosswalkMovement,
        data: {
          "stationId": station_id,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          return ({
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
          });
        } else {
          return ({ nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        }
      })
        .catch(function (error) {
          return ({ nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        })
    }
    catch (error) {
      return ({ nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
    }
  }

//This method is use for API call to get Lane geometry Data .... End
export const getIntersectionLaneGeometryMovement = (station_id) => {
  try {
    return axios({
      method: 'post',
      url: API_URL + API_PATH.getIdLaneGeometry,
      data: {
        "stationId": station_id,
      }
    }).then(function (response) {
      if (response && response.data.laneConfigId) {
        let laneConfigId = response.data.laneConfigId;
        if (laneConfigId !== '') {
          return axios({
            method: 'post',
            url: API_URL + API_PATH.getLaneGeometry,
            data: {
              "lane_id": laneConfigId,
            }
          })
        } else {
          return ({
            control_type: "", createdAt: "", eb_laneconfig: "0", eb_left_turn_phasing: null, eb_parking: false, eb_right_turn_phasing: null, lane_config_id: 0
            , nb_laneconfig: "0", nb_left_turn_phasing: 0, nb_parking: false, nb_right_turn_phasing: 0, sb_laneconfig: "0", sb_left_turn_phasing: 0, sb_parking: false
            , sb_right_turn_phasing: 0, stop_controlled: "None", updatedAt: "", wb_laneconfig: "0", wb_left_turn_phasing: null, wb_parking: false
            , wb_right_turn_phasing: null
          })
        }
      } else {
        return ({
          control_type: "", createdAt: "", eb_laneconfig: "0", eb_left_turn_phasing: null, eb_parking: false, eb_right_turn_phasing: null, lane_config_id: 0
          , nb_laneconfig: "0", nb_left_turn_phasing: 0, nb_parking: false, nb_right_turn_phasing: 0, sb_laneconfig: "0", sb_left_turn_phasing: 0, sb_parking: false
          , sb_right_turn_phasing: 0, stop_controlled: "None", updatedAt: "", wb_laneconfig: "0", wb_left_turn_phasing: null, wb_parking: false
          , wb_right_turn_phasing: null
        });
      }
    })
      .then(function (response) {
        return response.data.data;
      })
      .catch(function (error) {
        return ({
          control_type: "", createdAt: "", eb_laneconfig: "0", eb_left_turn_phasing: null, eb_parking: false, eb_right_turn_phasing: null, lane_config_id: 0
          , nb_laneconfig: "0", nb_left_turn_phasing: 0, nb_parking: false, nb_right_turn_phasing: 0, sb_laneconfig: "0", sb_left_turn_phasing: 0, sb_parking: false
          , sb_right_turn_phasing: 0, stop_controlled: "None", updatedAt: "", wb_laneconfig: "0", wb_left_turn_phasing: null, wb_parking: false
          , wb_right_turn_phasing: null
        });
      })
  }
  catch (error) {
    return ({
      control_type: "", createdAt: "", eb_laneconfig: "0", eb_left_turn_phasing: null, eb_parking: false, eb_right_turn_phasing: null, lane_config_id: 0
      , nb_laneconfig: "0", nb_left_turn_phasing: 0, nb_parking: false, nb_right_turn_phasing: 0, sb_laneconfig: "0", sb_left_turn_phasing: 0, sb_parking: false
      , sb_right_turn_phasing: 0, stop_controlled: "None", updatedAt: "", wb_laneconfig: "0", wb_left_turn_phasing: null, wb_parking: false
      , wb_right_turn_phasing: null
    });
  }
}